import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import { Device, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.nav `
  --buttonBgColour: ${brand.global.white};
  --buttonFgColour: ${brand.global.black};
  --buttonShadowColour: #bebebe;
  --buttonSize: ${fluid(40, 56)};
  --iconSize: 28px;

  display: flex;
  align-items: center;
  column-gap: ${fluid(8, 12)};
`;
const Button = styled.button `
  ${ButtonReset};
  ${transition('opacity')};

  z-index: 1;
  display: flex;
  width: var(--buttonSize);
  height: var(--buttonSize);
  background-color: var(--buttonBgColour);
  border-radius: 100%;
  color: var(--buttonFgColour);
  box-shadow: 0px 1px 12px 0px var(--buttonShadowColour);
  overflow: hidden;

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
    outline-color: var(--buttonFgColour);
  }

  /* Mobile click styles - button should mimic press */
  @media ${until(Device.TabletLarge)} {
    ${transition('transform', 0.15)};

    &:active {
      transform: translateY(1.5px);
    }
  }

  &.focus-ring,
  &:hover,
  &:active {
    svg:nth-child(1) {
      transform: translateX(var(--buttonSize));
    }

    svg:nth-child(2) {
      transform: translateX(0);
    }
  }

  &:disabled {
    opacity: 0.48;
    pointer-events: none;
  }
`;
const Icon = styled.span `
  display: grid;
  place-content: center;
  height: 100%;
  width: 100%;

  ${Button}[data-prev] & {
    transform: scale(-1);
  }

  svg {
    ${transition('transform')};

    grid-area: 1 / 1 / 1 / 1;
    display: block;
    width: var(--iconSize);

    &:nth-child(2) {
      transform: translateX(calc(var(--buttonSize) * -1));
    }
  }
`;
const ControlsStyles = {
    Container,
    Button,
    Icon,
};
export default ControlsStyles;
